var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何使用本地文件发起签约")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“发起签署”进入文件发起页面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img1.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "2.根据页面显示内容，依次上传需要签署的文件、填写签约方信息，选择审批流程（若未创建审批流程请先前往企业控制台创建），随后点击下一步；"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img2.png", alt: "" }
      }),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img3.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "3.根据页面提示在文件预览页面 中设置对应签署方需要用到电子签章的位置，设置完成点击 “立即发起”完成电子签约的文件发起。"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img4.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf3feb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf3feb7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/1_localFileSign.vue
// module id = 6sdV
// module chunks = 54 244